export interface AgentUrlIssue {
  kind: 'invalid' | 'localhost-on-device' | 'mixed-content';
  text: string;
}

const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '[::1]', '::1']);

interface Context {
  // `window.location.protocol` : « http: » ou « https: ».
  pageProtocol: string;
  // Une tablette ou un téléphone : « localhost » y désigne l'appareil lui-même, jamais le PC de l'imprimante.
  isMobile: boolean;
}

// Ce qui empêchera une adresse d'agent de marcher, dit avant l'impression plutôt qu'après un échec.
export const agentUrlIssue = (
  agentUrl: string,
  { pageProtocol, isMobile }: Context,
): AgentUrlIssue | null => {
  let url: URL;
  try {
    url = new URL(agentUrl.trim());
  } catch {
    return {
      kind: 'invalid',
      text: 'Adresse invalide. Exemple : http://192.168.1.10:4310',
    };
  }
  const local = LOCAL_HOSTS.has(url.hostname);

  if (local && isMobile)
    return {
      kind: 'localhost-on-device',
      text: 'Sur une tablette, « localhost » désigne la tablette elle-même. Saisissez l’adresse du PC où tourne l’agent, par exemple http://192.168.1.10:4310.',
    };

  // Un navigateur refuse d'appeler du http depuis une page https, sauf vers localhost.
  if (pageProtocol === 'https:' && url.protocol === 'http:' && !local)
    return {
      kind: 'mixed-content',
      text: 'Cette page est en https : le navigateur bloque l’appel à un agent en http. Ouvrez le kitchen en http sur le réseau local.',
    };

  return null;
};
